export function isHTML(string){
  return string
    && typeof string === 'string'
    && (string.includes('DOCTYPE') || string.includes('doctype'))
}

export function isNotAllowed(msg){
  if(typeof msg === 'string' && typeof msg.toLowerCase === 'function'){
    const lowered = msg.toLowerCase()
    if(
      lowered.includes('authentication')
      && lowered.includes('credentials')
      && lowered.includes('not provided')
    ){
      return true
    }
  }

  return false
}

export const notAllowedText = 'You are not allowed to see this content.'
